<script lang="ts" setup>
import { nextTick, watch } from 'vue';
import { useLoadingIndicator } from '#app/composables/loading-indicator';
import { useRoute } from '#app/composables/router';
import { useNuxtApp } from '#app/nuxt';
import { useChangingLayout } from '~/stores/loading';

const nuxtApp = useNuxtApp();
const route = useRoute();

// We display a full screen loading page only when changing the app shell (i.e. Nuxt layout)
const changingLayout = useChangingLayout();

// Reset changingLayout when the route's layout changes
// This prevents the spinner from appearing after the layout is already visible
// (dev-mode a11y checks delay page:loading:end, causing spinner to show after content)
watch(
	() => route.meta.layout,
	() => {
		nextTick(() => {
			changingLayout.value = false;
		});
	},
);

// Fallback: also reset on page:loading:end
nuxtApp.hook('page:loading:end', () => {
	changingLayout.value = false;
});

// Display after 200ms
const { isLoading } = useLoadingIndicator();
</script>

<template>
	<div
		v-if="isLoading && changingLayout"
		class="fixed inset-0 z-100000 flex items-center justify-center bg-default"
	>
		<DSpinner />
	</div>
</template>
